import { render, staticRenderFns } from "./FreeSessions.vue?vue&type=template&id=73bcb310&scoped=true&"
import script from "./FreeSessions.vue?vue&type=script&lang=js&"
export * from "./FreeSessions.vue?vue&type=script&lang=js&"
import style0 from "./minds.css?vue&type=style&index=0&lang=css&"
import style1 from "./FreeSessions.vue?vue&type=style&index=1&id=73bcb310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bcb310",
  null
  
)

export default component.exports